<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.full_name" id="profileDropdown">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.full_name }}</p>
      <small>MyIP Student</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-4">
        <!--- <img v-if="activeUserInfo.profile_picture" key="onlineImg" :src="activeUserInfo.profile_picture" alt="user-img" width="40" height="40" class="rounded shadow-md cursor-pointer block" /> --->
        <img
          key="onlineImg"
          :src="'https://portal-cdn.rapid.education/profile-pictures/default.jpeg'"
          alt="user-img"
          width="40"
          height="40"
          class="rounded shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="profileSettings = !profileSettings">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            ref="themeButton"
            @click="themeToggleSettings = !themeToggleSettings"
          >
            <feather-icon icon="SunIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Theme</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$fullscreen.toggle()">
            <feather-icon icon="Maximize2Icon" svgClasses="w-4 h-4" />
            <span class="ml-2">Full Screen</span>
          </li>

          <li ref="logoutButton" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup :active.sync="profileSettings" title="User Profile">
      <div class="p-2">
        <div class="flex items-center">
          <img
            v-if="activeUserInfo.profile_picture"
            :src="activeUserInfo.profile_picture"
            alt=""
            width="75"
            height="75"
            class="rounded shadow-md mr-4"
          />
          <div>
            <h1 class="font-bold">{{ activeUserInfo.full_name }}</h1>
            <h5 class="font-light">{{ activeUserInfo.email }}</h5>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :active.sync="themeToggleSettings" title="Choose Theme">
      <div class="p-2">
        <div class="vx-row mb-4">
          <div class="vx-col w-1/2 text-white cursor-pointer">
            <div
              class="border border-solid p-6 rounded-lg"
              style="background-color: #050056"
              @click="toggleTheme('dusk')"
              :class="currentTheme === 'dusk' ? 'border-success' : 'border-none'"
            >
              <div class="flex items-center justify-center">
                <feather-icon icon="CloudIcon" svgClasses="h-16 w-16 mr-2" />
                <h2 class="text-center text-white ml-2">Dusk</h2>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/2 text-white cursor-pointer">
            <div
              class="border border-solid p-6 rounded-lg"
              style="background-color: #1b1e22"
              @click="toggleTheme('dark')"
              :class="currentTheme === 'dark' ? 'border-success' : 'border-none'"
            >
              <div class="flex items-center justify-center">
                <feather-icon icon="MoonIcon" svgClasses="h-16 w-16 mr-2" />
                <h2 class="text-center text-white ml-2">Dark</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center">
          <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 mr-2" />
          <h5 class="font-light">The theme you select will sync to your account</h5>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import LottieAnimation from '../../../../components/lottie/LottieAnimation'

export default {
  data () {
    return {
      themeToggleSettings: false,
      profileSettings: false
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    currentTheme () {
      return this.$store.state.theme
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
      this.$router.push('/login')
    },
    toggleTheme (color) {
      if (color === 'dark' || color === 'dusk') {
        this.$vs.loading()
        this.$http
          .post('users/@me/theme', { theme: color })
          .then((response) => {
            this.$vs.loading.close()
            localStorage.setItem('selectedTheme', response.data.data.theme)
            this.$store.state.theme = response.data.data.theme
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      }
    }
  },
  components: {
    LottieAnimation
  }
}
</script>
<style lang="scss"></style>
